/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrowsableOffice,
    BrowsableOfficeFromJSON,
    BrowsableOfficeFromJSONTyped,
    BrowsableOfficeToJSON,
} from './';

/**
 * ログインユーザーの権限
 * @export
 * @interface Privileges
 */
export interface Privileges {
    /**
     * consoleログイン時に指定するID
     * @type {string}
     * @memberof Privileges
     */
    consoleUserId: string;
    /**
     * consoleで表示されるユーザー名
     * @type {string}
     * @memberof Privileges
     */
    consoleUserName: string;
    /**
     * consoleの利用権限
     * @type {Array<string>}
     * @memberof Privileges
     */
    consoleUserPermissions: Array<string>;
    /**
     * 
     * @type {Array<BrowsableOffice>}
     * @memberof Privileges
     */
    browsableOffices: Array<BrowsableOffice>;
}

export function PrivilegesFromJSON(json: any): Privileges {
    return PrivilegesFromJSONTyped(json, false);
}

export function PrivilegesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Privileges {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'consoleUserId': json['console_user_id'],
        'consoleUserName': json['console_user_name'],
        'consoleUserPermissions': json['console_user_permissions'],
        'browsableOffices': ((json['browsable_offices'] as Array<any>).map(BrowsableOfficeFromJSON)),
    };
}

export function PrivilegesToJSON(value?: Privileges | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'console_user_id': value.consoleUserId,
        'console_user_name': value.consoleUserName,
        'console_user_permissions': value.consoleUserPermissions,
        'browsable_offices': ((value.browsableOffices as Array<any>).map(BrowsableOfficeToJSON)),
    };
}


